import { LOG_SUPPRESSION_KEYWORDS } from '../constants/index';

const originalLog = console.log;
const originalInfo = console.info;

function shouldSuppress(...args) {
  return (
    typeof args[0] === 'string' &&
    LOG_SUPPRESSION_KEYWORDS.some(keyword => args[0].includes(keyword))
  );
}

console.log = function (...args) {
  if (shouldSuppress(...args)) return;
  originalLog.apply(console, args);
};

console.info = function (...args) {
  if (shouldSuppress(...args)) return;
  originalInfo.apply(console, args);
};

export {};
